import { env } from '@/env';

// Resolves the slug the dev harness lands on when the user opens / .
// Reads VITE_DEV_FALLBACK_SLUG (per requirements §2.14 seed convention)
// and falls back to the project's seed slug for local boot.
export function devFallbackSlug(): string {
  return env.devFallbackSlug;
}
